import { useRouter } from 'next/router';

import { FriendsOfTheKitchenPageDetailsType } from '../../../types/content';
import PageSection from '../../atoms/page-section/page-section';

export function PageContentWithImages(
  props: FriendsOfTheKitchenPageDetailsType
) {
  const {
    additionalImageDescription,
    additionalImageDimensions,
    additionalImage,
    mainImageDescription,
    mainImageDimensions,
    mainImage,
    subImageDescription,
    subImageDimensions,
    subImage,
    pageTitle
  } = props;

  const router = useRouter();

  const mainContent = mainImage && mainImageDescription && (
    <>
      {router.query['slug'] !== 'lea-salonga' ? (
        <PageSection
          alt={pageTitle}
          imageDescription={mainImageDescription}
          imageDimensions={mainImageDimensions}
          src={mainImage}
        />
      ) : null}
    </>
  );

  const subContent = subImage && subImageDescription && (
    <PageSection
      alt={pageTitle}
      imageDescription={subImageDescription}
      imageDimensions={subImageDimensions}
      src={subImage}
    />
  );

  const additionalContent = additionalImage && additionalImageDescription && (
    <PageSection
      alt={pageTitle}
      imageDescription={additionalImageDescription}
      imageDimensions={additionalImageDimensions}
      src={additionalImage}
    />
  );

  return (
    <>
      {mainContent}
      {subContent}
      {additionalContent}
    </>
  );
}

export default PageContentWithImages;
